import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sm-international-tax-configurer',
  templateUrl: './international-tax-configurer.component.html',
  styleUrls: ['./international-tax-configurer.component.scss']
})
export class InternationalTaxConfigurerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
